import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SettingsTableService {

    private initSettingsTableWorker(): Promise<Worker> {
        return import('webworker-promise/lib/index').then((module: any) => {
            return new module.default(new Worker(new URL('./../../workers/settings-table-dialog.worker', import .meta.url)));
        });
    }


    constructor() {
    }


    /**
     * Получить копию списка полей таблицы
     * @param list - массив полей для копирования
     */
    public getList(list: any[]): Promise<any[]> {
        return new Promise<any[]>((resolve) => {
            this.initSettingsTableWorker().then((worker: Worker | any) => {
                worker?.exec('deepCopyList', {list}).then((newLIst) => {
                    worker.terminate();
                    resolve(newLIst);
                });
            });
        });
    }

    public destructor() {
    }
}
